webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/* exports provided: app, router, store */
/* exports used: app */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(/*! ./components/App */ 31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! ./store */ 9);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));



/***/ }),
/* 4 */
/* unknown exports provided */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 5 */
/* unknown exports provided */
/* all exports used */
/*!***********************!*\
  !*** ./client/pwa.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(/*! offline-plugin/runtime */ 26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 6 */
/* exports provided: default */
/* exports used: default */
/*!***********************************!*\
  !*** ./client/lib/cartManager.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

var iframeId = 'attach-cart-iframe';
var iframeWrapperId = 'iframe-cart-holder';

var cartButton = void 0;
var cartForm = void 0;
var cartBrand = void 0;

// Clear the iframe wrapper
var getAndClearIframeWrapper = function getAndClearIframeWrapper() {
  var wrapper = document.getElementById(iframeWrapperId);
  wrapper.innerHTML = '';

  return wrapper;
};

var getAndAppendIframe = function getAndAppendIframe(wrapper) {
  var iframe = document.createElement('iframe');
  iframe.id = iframeId;
  iframe.name = iframeId;
  iframe.className = iframeId;
  iframe.style.width = '400px';
  iframe.style.height = '200px';
  iframe.style.display = 'none';
  wrapper.appendChild(iframe);

  return iframe;
};

var getIframeBody = function getIframeBody() {
  var iframe = document.getElementById(iframeId);
  var doc = iframe.contentDocument || iframe.contentWindow.document;

  return doc.body;
};

var getIframeForm = function getIframeForm(currentProduct) {
  if (!currentProduct || !currentProduct.cartMetadata) return;
  var form = document.createElement('form');
  form.action = currentProduct.cartMetadata.addToCartUrl;
  form.target = iframeId;
  form.method = 'POST';
  if (currentProduct && currentProduct.cartMetadata && currentProduct.cartMetadata.hiddenInputs) {
    currentProduct.cartMetadata.hiddenInputs.map(function (hiddenInput) {
      var input = document.createElement('input');
      input.type = 'hidden';
      for (var key in hiddenInput) {
        input[key] = hiddenInput[key];
      }

      form.appendChild(input);
    });
  }

  var button = document.createElement('button');
  button.type = 'submit';
  form.appendChild(button);

  // Keep reference to button.
  cartButton = button;
  cartForm = form;

  return form;
};

var checkIframeLoad = function checkIframeLoad(utm, eventObject) {
  var iframe = document.getElementById(iframeId);
  iframe.onload = function () {
    goToCart(utm, eventObject);
  };
};

var goToCart = function goToCart(utm, eventObject) {
  var cartUrl = cartBrand.cartLink;
  setTimeout(function () {
    fireEventAndRedirect('' + cartUrl + utm, eventObject);
  }, 500);
};

var fireEventAndRedirect = function fireEventAndRedirect(url, eventObject) {
  if (!amplitude) {
    var self = _this;
    setTimeout(function () {
      fireEventAndRedirect(url);
    }, 100);
    return;
  }

  amplitude.getInstance().logEvent('CART_LOADED', eventObject, function () {
    window.location = url;
  });
};

/* harmony default export */ __webpack_exports__["a"] = {
  createAndAppendFormToIframe: function createAndAppendFormToIframe(currentProduct, currentBrand, utm, eventObject) {
    cartBrand = currentBrand;
    var wrapper = getAndClearIframeWrapper();
    var iframe = getAndAppendIframe(wrapper);

    var body = getIframeBody();
    var form = getIframeForm(currentProduct);

    body.appendChild(form);
    window.clearInterval(window.iframeCartTimeout);

    cartButton.click();
    checkIframeLoad(utm, eventObject);
  }
};

/***/ }),
/* 7 */
/* exports provided: default */
/* exports used: default */
/*!*****************************!*\
  !*** ./client/lib/utils.js ***!
  \*****************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getConstantKeyFromStore = function getConstantKeyFromStore(state, key) {
  var constants = state.constants;
  var text = constants[key].default;
  if (state.currentPlayerLanguage) {
    var language = state.currentPlayerLanguage;
    if (constants[key][language]) {
      text = constants[key][language];
    }
  }

  return text;
};

/* harmony default export */ __webpack_exports__["a"] = {
  getConstantKeyFromStore: getConstantKeyFromStore
};

/***/ }),
/* 8 */
/* exports provided: default */
/* exports used: default */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(/*! ../views/Home */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/:platform/:trafficType/:cartId',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }]
});

/***/ }),
/* 9 */
/* exports provided: default */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_magnetight__ = __webpack_require__(/*! ./products/magnetight */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_nomorebaggage__ = __webpack_require__(/*! ./products/nomorebaggage */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products_poresnomore__ = __webpack_require__(/*! ./products/poresnomore */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__products_sayiloveyou__ = __webpack_require__(/*! ./products/sayiloveyou */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__products_veggiebullet__ = __webpack_require__(/*! ./products/veggiebullet */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products_nutribulletpro__ = __webpack_require__(/*! ./products/nutribulletpro */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__products_nutribullet__ = __webpack_require__(/*! ./products/nutribullet */ 12);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  carts: {
    magnetight: __WEBPACK_IMPORTED_MODULE_2__products_magnetight__["a" /* default */],
    nomorebaggage: __WEBPACK_IMPORTED_MODULE_3__products_nomorebaggage__["a" /* default */],
    poresnomore: __WEBPACK_IMPORTED_MODULE_4__products_poresnomore__["a" /* default */],
    nutribulletpro: __WEBPACK_IMPORTED_MODULE_7__products_nutribulletpro__["a" /* default */],
    magicbullet: __WEBPACK_IMPORTED_MODULE_8__products_nutribullet__["a" /* default */],
    veggiebullet: __WEBPACK_IMPORTED_MODULE_6__products_veggiebullet__["a" /* default */],
    SAYILOVEYOU: __WEBPACK_IMPORTED_MODULE_5__products_sayiloveyou__["a" /* default */]
  },
  constants: {
    'POWERED_BY_TEXT': {
      default: 'Powered by'
    }
  }
};

var mutations = {};

var actions = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 10 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./client/store/products/magnetight.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "brandId": "9bad8fdc-b5f0-44ee-90c9-63924999d3f0",
    "brandName": "Dr. Brandt",
    "brandSlug": "dr-brandt",
    "cartLink": "https://www.drbrandtskincare.com/cart",
    "cartName": "Dr. Brandt",
    "cartPlatform": "shopify",
    "category": "beauty",
    "modified_at": "Thu Jun 15 2017 10:32:43 GMT-0400 (EDT)",
    "modified_by": "adam@mikmak.tv",
    "tracking": "(function (url) { /*Tracking Bootstrap Set Up DataLayer objects/properties here*/ if(!window.DataLayer){ window.DataLayer = {}; } if(!DataLayer.events){ DataLayer.events = {}; } DataLayer.events.SiteSection = \"1\"; var loc, ct = document.createElement(\"script\");  ct.type = \"text/javascript\";  ct.async = true; ct.src = url; loc = document.getElementsByTagName(\"script\")[0]; loc.parentNode.insertBefore(ct, loc); }(document.location.protocol + \"//js.rmtag.com/112215.ct.js\"));",
    "trackingPixel": "//nypi.dc-storm.com/dcv4/logi.aspx?tsid=1030357&sid=112215&acid=109155&crf=54823&agrf=548233739637&adrf=16157250&rnd=[cachebuster]",
    "utmParameters": "?mikmakAttach=true&mikmakUserId=USER+ID+HERE&rmatt=tsid:1030357|cid:54823|cgid:548233739637|crid:16157250"
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.drbrandtskincare.com/cart/add.js",
      "hiddenInputs": [{
        "class": "original_select_7614779585",
        "data-productid": "7614779585",
        "name": "id",
        "value": "24311638401"
      }]
    },
    "productUrl": "https://drbrandtskincare.com/products/magnetight",
    "name": "MAGNETIGHT AGE DEFIER",
    "price": "75.00",
    "product-images": ["//cdn.shopify.com/s/files/1/1347/3227/products/Magnetite_acd78cb2-4236-4a18-be46-e0d529b12960_small.png?v=1473455478"],
    "slug": "magnetight-age-defier"
  }]
};

/***/ }),
/* 11 */
/* exports provided: default */
/* exports used: default */
/*!************************************************!*\
  !*** ./client/store/products/nomorebaggage.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "brandId": "9bad8fdc-b5f0-44ee-90c9-63924999d3f0",
    "brandName": "Dr. Brandt",
    "brandSlug": "dr-brandt",
    "cartLink": "https://www.drbrandtskincare.com/cart",
    "cartName": "Dr. Brandt",
    "cartPlatform": "shopify",
    "category": "beauty",
    "modified_at": "Thu Jun 15 2017 10:32:43 GMT-0400 (EDT)",
    "modified_by": "adam@mikmak.tv",
    "tracking": "(function (url) { /*Tracking Bootstrap Set Up DataLayer objects/properties here*/ if(!window.DataLayer){ window.DataLayer = {}; } if(!DataLayer.events){ DataLayer.events = {}; } DataLayer.events.SiteSection = \"1\"; var loc, ct = document.createElement(\"script\");  ct.type = \"text/javascript\";  ct.async = true; ct.src = url; loc = document.getElementsByTagName(\"script\")[0]; loc.parentNode.insertBefore(ct, loc); }(document.location.protocol + \"//js.rmtag.com/112215.ct.js\"));",
    "trackingPixel": "//nypi.dc-storm.com/dcv4/logi.aspx?tsid=1030357&sid=112215&acid=109155&crf=54823&agrf=548233739637&adrf=16157250&rnd=[cachebuster]",
    "utmParameters": "?mikmakAttach=true&mikmakUserId=USER+ID+HERE&rmatt=tsid:1030357|cid:54823|cgid:548233739637|crid:16157250"
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.drbrandtskincare.com/cart/add.js",
      "hiddenInputs": [{
        "class": "original_select_10523260557",
        "data-productid": "10523260557",
        "name": "id",
        "value": "41041949453"
      }]
    },
    "productUrl": "https://drbrandtskincare.com/products/needles-no-more-no-more-baggage",
    "name": "NO MORE BAGGAGE",
    "price": "42.00",
    "product-images": ["//cdn.shopify.com/s/files/1/1347/3227/products/no_more_bagage_1024x1024_929a550b-d519-4e6f-a27d-56eb56a41d60_1024x1024.png?v=1502247166"],
    "slug": "no-more-baggage"
  }]
};

/***/ }),
/* 12 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./client/store/products/nutribullet.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "active": true,
    "brandId": "ad2afdc0-2e3d-9b4a-2f3d-b1ad0319866f",
    "brandName": "NutriBullet",
    "brandSlug": "nutribullet",
    "cartLink": "https://www.nutriliving.com/cart",
    "cartName": "Capital Brands",
    "cartPlatform": "nutribullet",
    "cartSupport": true,
    "category": "consumer products and goods",
    "created_at": "Wed Jul 12 2017 11:05:03 GMT-0400 (EDT)",
    "created_by": "jordan@mikmak.tv",
    "modified_at": "Tue Aug 22 2017 16:58:07 GMT-0400 (EDT)",
    "modified_by": "maggie@mikmak.tv",
    "utmParameters": ""
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.nutriliving.com/cart/add/nl_mb/1",
      "hiddenInputs": []
    },
    "category": "kitchen",
    "description": "<br>Grate, grind, blend, chop and mix with one machine! <br> In just seconds, you can make: <br> &middot; Salsas <br> &middot; Pasta sauces <br> &middot; Frosty milkshakes <br> &middot; And more!",
    "id": 0,
    "name": "Magic Bullet",
    "price": "39.99",
    "product-images": ["//cartassets.imgix.net/img/636/nl_mb.jpg"],
    "productUrl": "https://www.nutriliving.com/shop/magic-bullet",
    "slug": "magic-bullet"
  }]
};

/***/ }),
/* 13 */
/* exports provided: default */
/* exports used: default */
/*!*************************************************!*\
  !*** ./client/store/products/nutribulletpro.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "active": true,
    "brandId": "ad2afdc0-2e3d-9b4a-2f3d-b1ad0319866f",
    "brandName": "NutriBullet",
    "brandSlug": "nutribullet",
    "cartLink": "https://www.nutriliving.com/cart",
    "cartName": "Capital Brands",
    "cartPlatform": "nutribullet",
    "cartSupport": true,
    "category": "consumer products and goods",
    "created_at": "Wed Jul 12 2017 11:05:03 GMT-0400 (EDT)",
    "created_by": "jordan@mikmak.tv",
    "modified_at": "Tue Aug 22 2017 16:58:07 GMT-0400 (EDT)",
    "modified_by": "maggie@mikmak.tv",
    "utmParameters": ""
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.nutriliving.com/cart/add/nl_nbp/1",
      "hiddenInputs": []
    },
    "name": "NutriBullet PRO",
    "price": "99.99",
    "product-images": ["//cartassets.imgix.net/img/636/nl_nbp.jpg"],
    "productUrl": "https://www.nutriliving.com/shop/nutribullet-pro",
    "slug": "nutribullet-pro"
  }]
};

/***/ }),
/* 14 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./client/store/products/poresnomore.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "brandId": "9bad8fdc-b5f0-44ee-90c9-63924999d3f0",
    "brandName": "Dr. Brandt",
    "brandSlug": "dr-brandt",
    "cartLink": "https://www.drbrandtskincare.com/cart",
    "cartName": "Dr. Brandt",
    "cartPlatform": "shopify",
    "category": "beauty",
    "modified_at": "Thu Jun 15 2017 10:32:43 GMT-0400 (EDT)",
    "modified_by": "adam@mikmak.tv",
    "tracking": "(function (url) { /*Tracking Bootstrap Set Up DataLayer objects/properties here*/ if(!window.DataLayer){ window.DataLayer = {}; } if(!DataLayer.events){ DataLayer.events = {}; } DataLayer.events.SiteSection = \"1\"; var loc, ct = document.createElement(\"script\");  ct.type = \"text/javascript\";  ct.async = true; ct.src = url; loc = document.getElementsByTagName(\"script\")[0]; loc.parentNode.insertBefore(ct, loc); }(document.location.protocol + \"//js.rmtag.com/112215.ct.js\"));",
    "trackingPixel": "//nypi.dc-storm.com/dcv4/logi.aspx?tsid=1030357&sid=112215&acid=109155&crf=54823&agrf=548233739637&adrf=16157250&rnd=[cachebuster]",
    "utmParameters": "?mikmakAttach=true&mikmakUserId=USER+ID+HERE&rmatt=tsid:1030357|cid:54823|cgid:548233739637|crid:16157250"
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.drbrandtskincare.com/cart/add.js",
      "hiddenInputs": [{
        "class": "original_select_8705460941",
        "data-productid": "8705460941",
        "name": "id",
        "value": "29782738573"
      }]
    },
    "productUrl": "https://www.drbrandtskincare.com/products/pores-no-more-multi-performance-stick",
    "name": "pores no more",
    "price": "35.00",
    "product-images": ["//cdn.shopify.com/s/files/1/1347/3227/products/multi-performance-stick_dt_1024x1024.jpg?v=1483975654"],
    "slug": "pores-no-more"
  }]
};

/***/ }),
/* 15 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./client/store/products/sayiloveyou.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "brandId": "9bad8fdc-b5f0-44ee-90c9-63924999d3f0",
    "brandName": "Dr. Brandt",
    "brandSlug": "dr-brandt",
    "cartLink": "https://www.drbrandtskincare.com/cart",
    "cartName": "Dr. Brandt",
    "cartPlatform": "shopify",
    "category": "beauty",
    "modified_at": "Thu Jun 15 2017 10:32:43 GMT-0400 (EDT)",
    "modified_by": "adam@mikmak.tv",
    "tracking": "(function (url) { /*Tracking Bootstrap Set Up DataLayer objects/properties here*/ if(!window.DataLayer){ window.DataLayer = {}; } if(!DataLayer.events){ DataLayer.events = {}; } DataLayer.events.SiteSection = \"1\"; var loc, ct = document.createElement(\"script\");  ct.type = \"text/javascript\";  ct.async = true; ct.src = url; loc = document.getElementsByTagName(\"script\")[0]; loc.parentNode.insertBefore(ct, loc); }(document.location.protocol + \"//js.rmtag.com/112215.ct.js\"));",
    "trackingPixel": "//nypi.dc-storm.com/dcv4/logi.aspx?tsid=1030357&sid=112215&acid=109155&crf=54823&agrf=548233739637&adrf=16157250&rnd=[cachebuster]",
    "utmParameters": "?mikmakAttach=true&mikmakUserId=USER+ID+HERE&rmatt=tsid:1030357|cid:54823|cgid:548233739637|crid:16157250"
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.drbrandtskincare.com/cart/add.js",
      "hiddenInputs": [{
        "class": "original_select_10643512973",
        "data-productid": "10643512973",
        "name": "id",
        "value": "42710360589"
      }]
    },
    "productUrl": "https://drbrandtskincare.com/products/sayiloveyou-kit",
    "name": "#SAYILOVEYOU Kit",
    "price": "38.00",
    "product-images": ["//cdn.shopify.com/s/files/1/1347/3227/products/say-ILoveU_1024x1024.png?v=1505052355"],
    "slug": "sayiloveyou-kit"
  }]
};

/***/ }),
/* 16 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./client/store/products/veggiebullet.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  brand: {
    "active": true,
    "brandId": "ad2afdc0-2e3d-9b4a-2f3d-b1ad0319866f",
    "brandName": "NutriBullet",
    "brandSlug": "nutribullet",
    "cartLink": "https://www.nutriliving.com/cart",
    "cartName": "Capital Brands",
    "cartPlatform": "nutribullet",
    "cartSupport": true,
    "category": "consumer products and goods",
    "created_at": "Wed Jul 12 2017 11:05:03 GMT-0400 (EDT)",
    "created_by": "jordan@mikmak.tv",
    "modified_at": "Tue Aug 22 2017 16:58:07 GMT-0400 (EDT)",
    "modified_by": "maggie@mikmak.tv",
    "utmParameters": ""
  },
  products: [{
    "cartMetadata": {
      "addToCartUrl": "https://www.nutriliving.com/cart/add/nl_vb/1",
      "hiddenInputs": []
    },
    "category": "kitchen",
    "description": "Features three automatic settings for slicing shredding spiralizing all of your produce, cheeses, and cooked meats, and more!",
    "id": 0,
    "name": "Veggie Bullet",
    "price": "149.95",
    "product-images": ["//cartassets.imgix.net/img/636/nl_vb.jpg"],
    "productUrl": "https://www.nutriliving.com/shop/veggie-bullet",
    "slug": "veggie-bullet"
  }]
};

/***/ }),
/* 17 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/CartSummary.vue ***!
  \*******************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_cartManager__ = __webpack_require__(/*! ../lib/cartManager */ 6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: [],
  data: function data() {
    return {
      notBenchmark: false
    };
  },

  components: {},
  mounted: function mounted() {
    this.initMagicCart();
  },

  computed: {
    brandImg: function brandImg() {
      if (!this.currentBrand) return '';
      var brandName = this.currentBrand.brandName;
      if (brandName == 'Dr. Brandt') return '//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/dr-brandt.png';
      if (brandName == 'NutriBullet') return '//nutriliving-images.imgix.net/images/logos/logo.svg';
      return '';
    },
    trafficType: function trafficType() {
      var type = this.$route.params.trafficType;
      if (type == 'p') return 'paid';
      return 'organic';
    },
    platform: function platform() {
      var platform = this.$route.params.platform;
      if (platform == 's') return 'snapchat';
      return 'instagram';
    },
    cartId: function cartId() {
      return this.$route.params.cartId;
    },
    currentCart: function currentCart() {
      return this.$store.state.carts[this.cartId];
    },
    currentBrand: function currentBrand() {
      if (!this.currentCart) return;
      return this.currentCart.brand;
    },
    currentProducts: function currentProducts() {
      if (!this.currentCart) return;
      return this.currentCart.products;
    },
    currentProduct: function currentProduct() {
      return this.currentProducts && this.currentProducts[0];
    }
  },
  methods: {
    initMagicCart: function initMagicCart() {

      // Divert 10% of traffic directly to product page.
      var randomOneThroughTen = this.random();
      if (randomOneThroughTen == 1 && !this.isTest()) return this.benchmarkTraffic();
      this.notBenchmark = true;
      __WEBPACK_IMPORTED_MODULE_0__lib_cartManager__["a" /* default */].createAndAppendFormToIframe(this.currentProduct, this.currentBrand, this.utmStandard(), this.eventObject());
    },
    benchmarkTraffic: function benchmarkTraffic() {
      var baseUrl = this.currentProduct.productUrl;
      var utm = this.utmForBenchmark();
      var url = '' + baseUrl + utm;
      this.goToUrl(url);
    },
    eventObject: function eventObject() {
      return {
        cartId: this.cartId,
        trafficType: this.trafficType,
        platform: this.platform
      };
    },
    goToUrl: function goToUrl(url) {
      if (!amplitude) {
        var self = this;
        setTimeout(function () {
          self.goToUrl(url);
        }, 100);
        return;
      }

      var name = 'CART_LOADED_BENCHMARK';
      amplitude.getInstance().logEvent(name, this.eventObject(), function () {
        window.location = url;
      });
    },
    utmForBenchmark: function utmForBenchmark() {
      var utm = '?utm_source=mikmak-magic-benchmark&utm_campaign=' + this.platform + '_' + this.trafficType + '_' + this.cartId;
      if (this.isTest()) utm = '';
      return utm;
    },
    utmStandard: function utmStandard() {
      var utm = '?utm_source=mikmak-magic&utm_campaign=' + this.platform + '_' + this.trafficType + '_' + this.cartId;
      if (this.isTest()) utm = '';
      return utm;
    },
    isTest: function isTest() {
      return window.location.search.indexOf('testmagic') != -1;
    },
    random: function random() {
      // Returns random number 1-10.
      return Math.floor(Math.random() * 10) + 1;
    }
  },
  watch: {}
};

/***/ }),
/* 18 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/MagicCart.vue ***!
  \*****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PoweredByMikMak__ = __webpack_require__(/*! ./PoweredByMikMak */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PoweredByMikMak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PoweredByMikMak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartSummary__ = __webpack_require__(/*! ./CartSummary */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartSummary__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  props: [],
  data: function data() {
    return {};
  },

  components: {
    PoweredByMikMak: __WEBPACK_IMPORTED_MODULE_0__PoweredByMikMak___default.a,
    CartSummary: __WEBPACK_IMPORTED_MODULE_1__CartSummary___default.a
  },
  mounted: function mounted() {
    this.initAmplitude();
  },

  computed: {
    cartId: function cartId() {
      return this.$route.params.cartId;
    },
    currentCart: function currentCart() {
      // TODO here is where we'll have to request cart.
      // firebaseService.getCart(this.cartId).then(...)...
    }
  },
  methods: {
    isTest: function isTest() {
      return window.location.search.indexOf('testmagic') != -1;
    },
    initAmplitude: function initAmplitude() {
      var self = this;
      if (!amplitude) {
        setTimeout(function () {
          self.initAmplitude();
        }, 100);
        return;
      }
      if (this.isTest()) {
        // amplitude: mikmak-magic-dev
        amplitude.getInstance().init('eff46ab0ca81ca3b5ba204caf889f2eb');
      } else {
        // amplitude: mikmak-magic-prod
        amplitude.getInstance().init('d5ca8bcb9fa8a62d3d566b3966ebe39c');
      }
    }
  },
  watch: {}
};

/***/ }),
/* 19 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/PoweredByMikMak.vue ***!
  \***********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils__ = __webpack_require__(/*! ../lib/utils */ 7);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: [],
  mounted: function mounted() {},

  computed: {
    currentVideoCanPlay: function currentVideoCanPlay() {
      return this.$store.state.currentVideoCanPlay;
    },
    poweredByText: function poweredByText() {
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils__["a" /* default */].getConstantKeyFromStore(this.$store.state, 'POWERED_BY_TEXT');
    }
  },
  methods: {},
  watch: {}
};

/***/ }),
/* 20 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Home.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_MagicCart__ = __webpack_require__(/*! components/MagicCart */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_MagicCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_MagicCart__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MagicCart: __WEBPACK_IMPORTED_MODULE_0_components_MagicCart___default.a
  }
};

/***/ }),
/* 21 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-1b108124","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-263441e9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/CartSummary.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-79445f30","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/MagicCart.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-8d6fdc74","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/PoweredByMikMak.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************!*\
  !*** ./client/assets/mikmak-logo-white.png ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-logo-white.b8b58a79.png";

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./client/components/App.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1b108124","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 21)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1b108124"}!../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************!*\
  !*** ./client/components/CartSummary.vue ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-263441e9","scoped":true,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./CartSummary.vue */ 22)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./CartSummary.vue */ 17),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-263441e9"}!../../~/vue-loader/lib/selector?type=template&index=0!./CartSummary.vue */ 37),
  /* scopeId */
  "data-v-263441e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************!*\
  !*** ./client/components/MagicCart.vue ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-79445f30","scoped":true,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./MagicCart.vue */ 23)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MagicCart.vue */ 18),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-79445f30"}!../../~/vue-loader/lib/selector?type=template&index=0!./MagicCart.vue */ 38),
  /* scopeId */
  "data-v-79445f30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************!*\
  !*** ./client/components/PoweredByMikMak.vue ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-8d6fdc74","scoped":true,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./PoweredByMikMak.vue */ 24)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./PoweredByMikMak.vue */ 19),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-8d6fdc74"}!../../~/vue-loader/lib/selector?type=template&index=0!./PoweredByMikMak.vue */ 40),
  /* scopeId */
  "data-v-8d6fdc74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/views/Home.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 20),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7cf2339c"}!../../~/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 39),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b108124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 37 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-263441e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/CartSummary.vue ***!
  \**************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentCart && _vm.notBenchmark),
      expression: "currentCart && notBenchmark"
    }],
    staticClass: "cart-wrapper"
  }, [_c('div', {
    staticClass: "cart-header-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cart-summary-wrapper"
  }, [_c('div', {
    staticClass: "cart-products-summary-wrapper"
  }, _vm._l((_vm.currentProducts), function(product) {
    return _c('div', {
      staticClass: "cart-product-detail"
    }, [_c('span', {
      staticClass: "cart-product-image-wrapper"
    }, [_c('img', {
      staticClass: "cart-product-image",
      attrs: {
        "src": product['product-images'][0]
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "cart-product-name"
    }, [_vm._v("\n          " + _vm._s(product.name) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "cart-product-price"
    }, [_vm._v("\n          $" + _vm._s(product.price) + "\n        ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "cart-summary-heading"
  }, [_vm._v("\n      Loading product on " + _vm._s(_vm.currentBrand && _vm.currentBrand.brandName) + "\n    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "iframe-cart-holder"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-1x fa-fw"
  })])
}]}

/***/ }),
/* 38 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-79445f30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/MagicCart.vue ***!
  \************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('CartSummary'), _vm._v(" "), _c('PoweredByMikMak')], 1)
},staticRenderFns: []}

/***/ }),
/* 39 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cf2339c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('MagicCart')], 1)
},staticRenderFns: []}

/***/ }),
/* 40 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d6fdc74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/PoweredByMikMak.vue ***!
  \******************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by-mikmak-white",
    attrs: {
      "id": "powered-by-mikmak-white"
    }
  }, [_c('label', {
    staticClass: "powered-by-mikmak-text"
  }, [_vm._v(_vm._s(_vm.poweredByText))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(/*! ../assets/mikmak-logo-white.png */ 25),
      "alt": "powered by MikMak"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/* unknown exports provided */
/* all exports used */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 3);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(/*! ./pwa */ 5);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[45]);


// WEBPACK FOOTER //
// client.d082be09.js